import clsx from "clsx";
import { Link } from "gatsby";
import React, { forwardRef } from "react";

import { useHeaderMenu } from "../../../../hooks/use-header-menu";
import { getLocalizedPath } from "../../../../utils/pages";
import { BiesseLogo } from "../../../biesse-logo";
import { IconButton } from "../../../buttons/icon-button";
import { Icon } from "../../../icon";

export interface HeaderMenuMainProps {
  className?: string;
}

export const HeaderMenuMain = forwardRef<HTMLDivElement, HeaderMenuMainProps>(
  ({ className }, ref) => {
    const {
      isMenuOpen,
      isSpecialItemOpen,
      setMenuOpen,
      headerMenu: { node_locale },
    } = useHeaderMenu();

    return (
      <div className={clsx("flex items-center justify-between gap-2", className)} ref={ref}>
        <Link to={getLocalizedPath("/", node_locale)}>
          <BiesseLogo
            className={clsx(
              "h-9",
              isMenuOpen && !isSpecialItemOpen ? "!text-light" : "!text-primary"
            )}
            monochrome={isMenuOpen && !isSpecialItemOpen}
          />
        </Link>
        {isMenuOpen ? (
          <Icon
            size={40}
            className={clsx("w-10 cursor-pointer", !isSpecialItemOpen && "text-light")}
            icon="close"
            onClick={() => setMenuOpen(false)}
          />
        ) : (
          <IconButton icon="hamburger" variant="light" onClick={() => setMenuOpen(true)} />
        )}
      </div>
    );
  }
);
